import React from 'react';
import { useSelector } from 'react-redux';

import { ROLLOUT_VIDEO_PLAYER_END_SCREEN } from 'constants/featureFlag';
import { selectUserIsOwner } from 'selectors/shareVideo';
import { selectUserIsLogged } from 'selectors/user';

import { useFlagIsActivated } from 'hooks/featureFlag';

import OldEndScreen from './old';
import NewEndScreen from './rework';

export default function EndScreen(props) {
  const featureFlagActive = useFlagIsActivated({
    flag: ROLLOUT_VIDEO_PLAYER_END_SCREEN,
    activationValues: ['variant'],
  });

  const isOwner = useSelector(selectUserIsOwner);
  const isLoggedIn = useSelector(selectUserIsLogged);

  // as we implement components of the new end screen, this logic will change
  // for now, we're just going to have the non-owner version
  const showNew = featureFlagActive && !isOwner && isLoggedIn;

  return showNew ? (
    <NewEndScreen {...props} />
  ) : (
    <OldEndScreen isOwner={isOwner} {...props} />
  );
}
